import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthSimpleLayout from "../layouts/AuthSimpleLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import MainLayout from "../layouts/MainLayout";

import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import SimpleForgetPassword from "components/authentication/simple/ForgetPassword";
import SimpleLogin from "components/authentication/simple/Login";
import SimplePasswordReset from "components/authentication/simple/PasswordReset";

import Dashboard from "components/dashboards/default";

import ChartofAccountsTable from "components/modules/accounts/chart-of-accounts/ChartofAccountsTable";
import AddCostCenter from "components/modules/accounts/cost-center/add-cost-center/AddCostCenter";
import CostCenterTable from "components/modules/accounts/cost-center/CostCenterTable";
import AddFiscalYear from "components/modules/accounts/fiscal-year/add-fiscal-year/AddFiscalYear";
import FiscalYearTable from "components/modules/accounts/fiscal-year/FiscalYearTable";
import AddRole from "components/modules/administration-menu/RolesPermission/add-role-permission/AddRole";
import RolePermissionTable from "components/modules/administration-menu/RolesPermission/RolePermissionTable";
import AddUser from "components/modules/administration-menu/Users/add-user/AddUser";
import UsersTable from "components/modules/administration-menu/Users/UsersTable";
import CustomersTable from "components/modules/customers/CustomersTable";
import CustomerDetails from "components/modules/customers/details/CustomerDetails";
import CustomerEstimateDetails from "components/modules/customers/details/CustomerEstimateDetails";
import CustomerEstimatesTable from "components/modules/customers/details/CustomerEstimatesTable";
import EstimateDetail from "components/modules/estimates/details/EstimateDetail";
import EstimatesTable from "components/modules/estimates/EstimatesTable";
import CategoriesPage from "components/modules/libraries-menu/Categories/CategoriesPage";
import AddCategoryFieldSet from "components/modules/libraries-menu/CategoryFieldSets/add-category-fieldset/AddCategoryFieldSet";
import CategoryFieldSetsTable from "components/modules/libraries-menu/CategoryFieldSets/CategoryFieldSetsTable";
import AddCategoryGroup from "components/modules/libraries-menu/CategoryGroups/add-category-group/AddCategoryGroup";
import CategoryGroupsTable from "components/modules/libraries-menu/CategoryGroups/CategoryGroupsTable";
import AddCategoryVariants from "components/modules/libraries-menu/CategoryVariants/add-category-variants/AddCategoryVariants";
import CategoryVariantsTable from "components/modules/libraries-menu/CategoryVariants/CategoryVariantsTable";
import FieldSetsForm from "components/modules/libraries-menu/FieldSets/add-fieldset/FieldSetsForm";
import FieldSetTable from "components/modules/libraries-menu/FieldSets/FieldSetsTable";
// import AddProduct from "components/modules/libraries-menu/Products/add-product/AddProduct";
import ProductsTable from "components/modules/libraries-menu/Products/ProductsTable";
import AddVariants from "components/modules/libraries-menu/Variants/add-variants/AddVariants";
import VariantsTable from "components/modules/libraries-menu/Variants/VariantsTable";
import AddPageGroup from "components/modules/page-group/add-page-group/AddPageGroup";
import PageGroupTable from "components/modules/page-group/PageGroupTable";
import AddPage from "components/modules/pages/add-page/AddPage";
import PagesTable from "components/modules/pages/PagesTable";
import GeneralDetail from "components/modules/setting/general/details/GeneralDetail";
import GeneralTable from "components/modules/setting/general/GeneralTable";
import AddSlider from "components/modules/slider/details/AddSlider";
import SliderTable from "components/modules/slider/SliderTable";
import Profile from "components/pages/user/profile/Profile";
import { ChartOfAccountsContextProvider } from "context/ChartOfAccountContext";
import { FiscalYearContextProvider } from "context/FiscalYearContext";
import AuthGuard from "./Gaurd/AuthGaurd";

import AddFinanceBook from "components/modules/accounts/finance-books/add-finance-book/AddFinanceBook";
import FinanceBooksTable from "components/modules/accounts/finance-books/FinanceBooksTable";
import BatchPostingTable from "components/modules/accounts/voucher/batch-posting/BatchPostingTable";
import AddVoucher from "components/modules/accounts/voucher/entries/add-voucher/AddVoucher";
import VoucherPrint from "components/modules/accounts/voucher/entries/add-voucher/VoucherPrint";
import VouchersTable from "components/modules/accounts/voucher/entries/VouchersTable";
import AccountPayableReport from "components/modules/reporting/account-payable/AccountPayableReport";
import AccountReceivableReport from "components/modules/reporting/account-receivable/AccountReceivableReport";
import BalanceSheetReport from "components/modules/reporting/balance-sheet/BalanceSheetReport";
import CashFlowReport from "components/modules/reporting/cash-flow/CashFlowReport";
import GeneralLedgerReport from "components/modules/reporting/general-ledger/GeneralLedgerReport";
import ProfitAndLossReport from "components/modules/reporting/profit-loss/ProfitAndLossReport";
import TrialBalanceReport from "components/modules/reporting/trial-balance/TrialBalanceReport";
import VoucherReport from "components/modules/reporting/vouchers/VoucherResport";
import { SettingsContextProvider } from "context/SettingContext";
import AddIndicator from "modules/libraries/indicators/add-indicator/AddIndicator";
import IndicatorsTable from "modules/libraries/indicators/IndicatorsTable";
import AddSite from "modules/libraries/site/add-site/AddSite";
import SiteTable from "modules/libraries/site/SiteTable";
import AddCompany from "modules/super_administration/companies/add-company/AddCompany";
import CompaniesTable from "modules/super_administration/companies/CompaniesTable";
import AddParty from "modules/super_administration/parties/add-party/AddParty";
import PartiesTable from "modules/super_administration/parties/PartiesTable";
import AddFinalWeight from "modules/weighments/weightment_entry/add-entry/add-final-weight/AddFinalWeight";
import AddSecondWeight from "modules/weighments/weightment_entry/add-entry/add-second-weight/AddSecondWeight";
import AddWeighmentEntry from "modules/weighments/weightment_entry/add-entry/AddWeighmentEntry";
import WeighmentEntryTable from "modules/weighments/weightment_entry/WeighmentEntryTable";

import AddOrder from "modules/e-commerce/orders/add-order/AddOrder";
import OrdersTable from "modules/e-commerce/orders/OrdersTable";
import AddPayment from "modules/e-commerce/payments/add-pyament/AddPayment";
import PaymentsTable from "modules/e-commerce/payments/PaymentsTable";
import AddPromotion from "modules/e-commerce/promotions/add-promotion/AddPromotion";
import PromotionsTable from "modules/e-commerce/promotions/PromotionsTable";
import AddReview from "modules/e-commerce/reviews/add-review/AddReview";
import ReviewsTable from "modules/e-commerce/reviews/ReviewsTable";
import AddShipping from "modules/e-commerce/shippings/add-shipping/AddShipping";
import ShippingTable from "modules/e-commerce/shippings/ShippingTable";
import AddCartItem from "../modules/e-commerce/cart-items/add-cart-item/AddCartItem";
import CartItemsTable from "../modules/e-commerce/cart-items/CartItemsTable";
import AddWishlist from "../modules/e-commerce/wishlist/add-wishlist/AddWishlist";
import WishListTable from "../modules/e-commerce/wishlist/WishListTable";
// import AddSeller from "../modules/fbr-digital-invoices/sellers/add-seller/AddSeller";
// import SellerTable from "../modules/fbr-digital-invoices/sellers/SellerTable";

import SocialPlatformTable from "components/modules/libraries-menu/social-platforms/SocialPlatformTable";
import AddSocialPlatform from "components/modules/libraries-menu/social-platforms/add-social-platform/AddSocialPlatform";

import AddSeller from "modules/shopenze/sellers/add-seller/AddSeller";
import SellersTable from "modules/shopenze/sellers/SellersTable";
import AddMarqueeMessage from "../modules/shopenze/marquee_message/add-marquee_message/AddMarqueeMessage";
import MarqueeMessageTable from "../modules/shopenze/marquee_message/MarqueeMessageTable";
import AddMarqueeMessageTest from "../modules/shopenze/marquee_message_test/add-marquee_message_test/AddMarqueeMessageTest";
import TableView from "../modules/shopenze/marquee_message_test/TableView";
import TableViewTestOne from "../modules/shopenze/marquee_message_test_one/TableViewTestOne";
import HomePageTable from "../modules/shopenze/home_page/HomePageTable";
import PageBuilder from "../modules/shopenze/home_page/forms/PageBuilder";
import ImageIconExample from "../components/examples/ImageIconExample";
// import AddSeller from "../modules/fbr-digital-invoices/sellers/add-seller/AddSeller";

import AddProduct from "modules/shopenze/sellers/views/products-view/add-product/AddProduct";
import AddVariantsV1 from "components/modules/libraries-menu/VariantsV1/add-variants/AddVariantsV1";
import ApprovalRequestsTable from "../modules/requests/approval-requests/ApprovalRequestsTable";

export const CONSTANT_ROUTES = {
  AUTHENTICATION_LOGIN: "/login",
  AUTHENTICATION_REGISTER: "/register",
  AUTHENTICATION_RESET_PASSWORD: "/reset-password",
  AUTHENTICATION_FORGOT_PASSWORD: "/forgot-password",
  USERPROFILE: "/userProfile",
  HOME: "/",
  CATEGORIES_PAGE: "/libraries/categories",
  CATEGORY_GROUPS_PAGE: "/libraries/category-groups",
  CATEGORY_GROUPS_ADD: "/libraries/category-groups/add-new",
  FIELD_SETS_TABLE: "/libraries/fieldSets",
  FIELD_SETS_ADD: "/libraries/fieldSets/add-new",
  CATEGORY_FIELDSET_TABLE: "/libraries/category-fieldset",
  CATEGORY_FIELDSET_ADD: "/libraries/category-fieldset/add-new",
  CATEGORY_VARIANTS_TABLE: "/libraries/category-variants",
  CATEGORY_VARIANTS_ADD: "/libraries/category-variants/add-new",
  PRODUCTS_TABLE: "/libraries/products",
  PRODUCTS_ADD: "/libraries/products/add-new",
  VARIANTS_TABLE: "/libraries/variants",
  VARIANTS_ADD: "/libraries/variants/add-new",

  SOCIAL_PLATFORMS_TABLE: "/libraries/social-platforms",
  SOCIAL_PLATFORM_ADD: "/libraries/social-platforms/add-new",

  PAGES_TABLE: "/pages",
  PAGES_ADD: "/pages/add-new",
  PAGE_GROUPS_TABLE: "/page-groups",
  PAGE_GROUP_ADD: "/page-groups/add-new",
  CUSTOMERS_TABLE: "/customers",
  CUSTOMER_TABLE_DETAIL: "/customers/detail",
  ESTIMATES_TABLE: "/estimates",
  ESTIMATES_TABLE_DETAILS: "/estimates/detail",
  CUSTOMER_ESTIMATE_TABLE: "/customer-estimates",
  CUSTOMER_ESTIMATE_DETAILS: "/customer-estimates/detail",

  USERS_TABLE: "/administration/users",
  USER_ADD: "/administration/users/add-new",

  ROLE_PERMISSION_TABLE: "/administration/roles",
  ROLES_PERMISSION_ADD: "/administration/roles/add-new",

  SETTING_GENERAL: "/settings/general",
  SETTING_GENERAL_UPDATE: "/settings/general/update",

  SLIDER_TABLE: "/slider",
  SLIDER_UPDATE: "/slider/add-new",

  HOME_PAGE_TABLE: "/home-page",
  HOME_PAGE_UPDATE: "/home-page/add-new",

  COST_CENTER: "/accounts/cost-center",
  COST_CENTER_ADD: "/accounts/cost-center/add-new",

  FISCAL_YEAR: "/accounts/fiscal-year",
  FISCAL_YEAR_ADD: "/accounts/fiscal-year/add-new",
  FISCAL_PERIOD_ADD: "/accounts/fiscal-period/add-new",

  FINANCE_BOOKS: "/accounts/finance-books",
  FINANCE_BOOK_ADD: "/accounts/finance-books/add-new",

  VOUCHERS: "/accounts/vouchers",
  VOUCHER_ADD: "/accounts/vouchers/add-new",
  BATCH_POSTING: "/accounts/posting",
  VOUCHER_PRINT: "/accounts/vouchers/print",

  CHART_OF_ACCOUNTS_TABLE: "/accounts/chart-of-accounts",

  COMPANIES_TABLE: "/company",
  COMPANY_ADD: "/company/add-new",

  PARTIES_TABLE: "/libraries/party",
  PARTY_ADD: "/libraries/party/add-new",
  WEIGHMENTS_TABLE: "/weighment",
  WEIGHMENT_ADD: "/weighment/add-first-weight",
  SECOND_WEIGHT_ADD: "/weighment/add-second-weight",
  FINAL_WEIGHT_ADD: "/weighment/add-final-weight",
  INDICATORS_TABLE: "/libraries/weighment-indicators",
  INDICATOR_ADD: "/libraries/weighment-indicators/add-new",
  SITE_TABLE: "/libraries/weighment-sites",
  SITE_ADD: "/libraries/weighment-sites/add-new",

  // Reports
  VOUCHER_REPORT: "/accounts/reports/voucher",
  GENERAL_LEDGER_REPORT: "/accounts/reports/ledger",
  TRIAL_BALANCE_REPORT: "/accounts/reports/trialbalance",
  BALANCE_SHEET_REPORT: "/accounts/reports/balancesheet",
  PROFIT_LOSS_REPORT: "/accounts/reports/profitloss",
  ACCOUNTS_RECEIVABLE_REPORT: "/accounts/reports/receivable",
  ACCOUNTS_PAYABLE_REPORT: "/accounts/reports/payable",
  CASH_FLOW_REPORT: "/accounts/reports/cashflow",

  // =============Ecommerece===============
  ORDERS: "/orders",
  ORDER_ADD: "/orders/view",
  ORDER_DETAILS: "/orders/details",
  PAYMENTS: "/payments",
  PAYMENT_ADD: "/payments/view",
  SHIPPING: "/shipping",
  SHIPPING_ADD: "/shipping/view",
  PROMOTIONS: "/promotions",
  PROMOTION_ADD: "/promotions/view",
  REVIEWS: "/reviews",
  REVIEW_ADD: "/reviews/view",
  CARTS: "/carts",
  CART_ADD: "/carts/view",
  WISHLISTS: "/wishlists",
  WISHLIST_ADD: "/wishlists/view",

  // ===============FBR===================

  SELLERS: "/sellers",
  SELLER_ADD: "/sellers/add-new",
  PRODUCT_VIEW_PAGE: "/sellers/add-new/product-view",
  DIGITAL_INVOICES: "/digital-invoices",
  DIGITAL_INVOICE_ADD: "/digital-invoices/add-new",

  MARQUEE_MESSAGES_TABLE: "/marquee-messages",
  MARQUEE_MESSAGES_ADD: "/marquee-messages/add-new",
  MARQUEE_MESSAGES_TABLE_TEST: "/marquee-messages-test",
  MARQUEE_MESSAGES_TABLE_TEST_ONE: "/marquee-messages-test-one",
  MARQUEE_MESSAGES_ADD_TEST: "/marquee-messages-test/add-new",

  APPROVAL_REQUESTS_TABLE: "/approval-request",
};

const FalconRoutes = () => {
  return (
    <Routes>
      {/* <Route path="landing" element={<Landing />} /> */}
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      {/*- ------------- Authentication ---------------------------  */}

      {/*- ------------- simple ---------------------------  */}
      <Route element={<AuthSimpleLayout />}>
        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_LOGIN}
          element={<SimpleLogin />}
        />
        {/* <Route
          path="authentication/register"
          element={<SimpleRegistration />}
        /> */}
        <Route
          path={CONSTANT_ROUTES.AUTHENTICATION_FORGOT_PASSWORD}
          element={<SimpleForgetPassword />}
        />

        {/* <Route
          path="authentication/lock-screen"
          element={<SimpleLockScreen />}
        />
        <Route path="authentication/logout" element={<SimpleLogout />} />
       
   
        <Route
          path="authentication/confirm-mail"
          element={<SimpleConfirmMail />}
        /> */}
      </Route>

      {/* //--- MainLayout Starts  */}

      <Route element={<AuthGuard />}>
        <Route
          element={
            <SettingsContextProvider>
              <MainLayout />
            </SettingsContextProvider>
          }
        >
          <Route
            path={CONSTANT_ROUTES.AUTHENTICATION_RESET_PASSWORD}
            element={<SimplePasswordReset />}
          />
          {/*Dashboard*/}
          <Route path="/" element={<Dashboard />} />

          {/* =============Libraries=============== */}
          {/* <Route path="/libraries/categories" element={<CategoriesTable />} />
          <Route
            path="/libraries/categories/add-new-category"
            element={<AddCategory />}
          /> */}

          <Route
            path={CONSTANT_ROUTES.HOME_PAGE_TABLE}
            element={<HomePageTable />}
          />
          <Route
            path={CONSTANT_ROUTES.HOME_PAGE_UPDATE}
            element={<PageBuilder />}
          />

          <Route
            path={CONSTANT_ROUTES.CATEGORIES_PAGE}
            element={<CategoriesPage />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_GROUPS_PAGE}
            element={<CategoryGroupsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_GROUPS_ADD}
            element={<AddCategoryGroup />}
          />
          <Route
            path={CONSTANT_ROUTES.FIELD_SETS_TABLE}
            element={<FieldSetTable />}
          />
          <Route
            path={CONSTANT_ROUTES.FIELD_SETS_ADD}
            element={<FieldSetsForm />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_FIELDSET_TABLE}
            element={<CategoryFieldSetsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_FIELDSET_ADD}
            element={<AddCategoryFieldSet />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_VARIANTS_TABLE}
            element={<CategoryVariantsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CATEGORY_VARIANTS_ADD}
            element={<AddCategoryVariants />}
          />
          <Route
            path={CONSTANT_ROUTES.VARIANTS_TABLE}
            element={<VariantsTable />}
          />
          {/* <Route
            path={CONSTANT_ROUTES.VARIANTS_ADD}
            element={<AddVariants />}
          /> */}
          <Route
            path={CONSTANT_ROUTES.VARIANTS_ADD}
            element={<AddVariantsV1 />}
          />
          <Route
            path={CONSTANT_ROUTES.SOCIAL_PLATFORMS_TABLE}
            element={<SocialPlatformTable />}
          />
          <Route
            path={CONSTANT_ROUTES.SOCIAL_PLATFORM_ADD}
            element={<AddSocialPlatform />}
          />
          {/* <Route
            path={CONSTANT_ROUTES.PRODUCTS_TABLE}
            element={<ProductsTable />}
          />
          <Route path={CONSTANT_ROUTES.PRODUCTS_ADD} element={<AddProduct />} /> */}
          <Route path={CONSTANT_ROUTES.PAGES_ADD} element={<AddPage />} />
          <Route path={CONSTANT_ROUTES.PAGES_TABLE} element={<PagesTable />} />
          <Route
            path={CONSTANT_ROUTES.PAGE_GROUPS_TABLE}
            element={<PageGroupTable />}
          />
          <Route
            path={CONSTANT_ROUTES.PAGE_GROUP_ADD}
            element={<AddPageGroup />}
          />
          <Route
            path={CONSTANT_ROUTES.SLIDER_TABLE}
            element={<SliderTable />}
          />
          <Route path={CONSTANT_ROUTES.SLIDER_UPDATE} element={<AddSlider />} />
          <Route
            path={CONSTANT_ROUTES.ESTIMATES_TABLE}
            element={<EstimatesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ESTIMATES_TABLE_DETAILS}
            element={<EstimateDetail />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMERS_TABLE}
            element={<CustomersTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMER_TABLE_DETAIL}
            element={<CustomerDetails />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMER_ESTIMATE_TABLE}
            element={<CustomerEstimatesTable />}
          />
          <Route
            path={CONSTANT_ROUTES.CUSTOMER_ESTIMATE_DETAILS}
            element={<CustomerEstimateDetails />}
          />
          <Route
            path={CONSTANT_ROUTES.SETTING_GENERAL}
            element={<GeneralTable />}
          />
          <Route
            path={CONSTANT_ROUTES.SETTING_GENERAL_UPDATE}
            element={<GeneralDetail />}
          />

          <Route
            path={CONSTANT_ROUTES.COST_CENTER}
            element={<CostCenterTable />}
          />
          <Route
            path={CONSTANT_ROUTES.COST_CENTER_ADD}
            element={<AddCostCenter />}
          />

          <Route
            path={CONSTANT_ROUTES.FISCAL_YEAR}
            element={
              <FiscalYearContextProvider>
                <FiscalYearTable />
              </FiscalYearContextProvider>
            }
          />
          <Route
            path={CONSTANT_ROUTES.FISCAL_YEAR_ADD}
            element={
              <FiscalYearContextProvider>
                <AddFiscalYear />
              </FiscalYearContextProvider>
            }
          />
          {/* <Route
            path={CONSTANT_ROUTES.FISCAL_PERIOD_ADD}
            element={
              // <FiscalYearContextProvider>
              <AddFiscalPeriod />
              // </FiscalYearContextProvider>
            }
          /> */}
          <Route
            path={CONSTANT_ROUTES.FINANCE_BOOKS}
            element={<FinanceBooksTable />}
          />
          <Route
            path={CONSTANT_ROUTES.FINANCE_BOOK_ADD}
            element={<AddFinanceBook />}
          />
          <Route path={CONSTANT_ROUTES.VOUCHERS} element={<VouchersTable />} />
          <Route path={CONSTANT_ROUTES.VOUCHER_ADD} element={<AddVoucher />} />
          <Route
            path={CONSTANT_ROUTES.BATCH_POSTING}
            element={<BatchPostingTable />}
          />
          <Route
            path={CONSTANT_ROUTES.VOUCHER_PRINT}
            element={<VoucherPrint />}
          />

          <Route
            path={CONSTANT_ROUTES.CHART_OF_ACCOUNTS_TABLE}
            element={
              <ChartOfAccountsContextProvider>
                <ChartofAccountsTable />
              </ChartOfAccountsContextProvider>
            }
          />

          {/* ============================Reporting============================ */}

          <Route
            path={CONSTANT_ROUTES.VOUCHER_REPORT}
            element={<VoucherReport />}
          />
          <Route
            path={CONSTANT_ROUTES.GENERAL_LEDGER_REPORT}
            element={<GeneralLedgerReport />}
          />
          <Route
            path={CONSTANT_ROUTES.TRIAL_BALANCE_REPORT}
            element={<TrialBalanceReport />}
          />
          <Route
            path={CONSTANT_ROUTES.BALANCE_SHEET_REPORT}
            element={<BalanceSheetReport />}
          />
          <Route
            path={CONSTANT_ROUTES.PROFIT_LOSS_REPORT}
            element={<ProfitAndLossReport />}
          />
          <Route
            path={CONSTANT_ROUTES.ACCOUNTS_RECEIVABLE_REPORT}
            element={<AccountReceivableReport />}
          />
          <Route
            path={CONSTANT_ROUTES.ACCOUNTS_PAYABLE_REPORT}
            element={<AccountPayableReport />}
          />
          <Route
            path={CONSTANT_ROUTES.CASH_FLOW_REPORT}
            element={<CashFlowReport />}
          />

          {/* <Route path={CONSTANT_ROUTES.PRODUCTS_ADD} element={<AddProduct />} /> */}

          {/* ===============Libraries End================ */}

          {/*============================Administration=========================  */}

          {/* <Route path="/groups" element={<GroupsTable />} />
          <Route path="/groups/add-new-group" element={<AddGroup />} /> */}
          {/* <Route
            path="/administration/roles-and-permissions"
            element={<RolesAndPermissionsTable />}
          />
          <Route
            path="/administration/roles-and-permissions/add-new-role"
            element={<AddRoleAndPermission />}
          />
          <Route
            path="/administration/roles-and-permissions/assignment"
            element={<AddAssignment />}
          /> */}
          <Route
            path={CONSTANT_ROUTES.ROLE_PERMISSION_TABLE}
            element={<RolePermissionTable />}
          />
          <Route
            path={CONSTANT_ROUTES.ROLES_PERMISSION_ADD}
            element={<AddRole />}
          />
          <Route path={CONSTANT_ROUTES.USERS_TABLE} element={<UsersTable />} />
          <Route path={CONSTANT_ROUTES.USER_ADD} element={<AddUser />} />
          {/* <Route path="/infinite-scroll" element={<AgGridInfiniteScroll />} />
          <Route path="/map" element={<GoogleMapExample />} /> */}

          {/*============================Administration End=========================  */}
          {/*============================Super Administration=========================  */}

          <Route
            path={CONSTANT_ROUTES.COMPANIES_TABLE}
            element={<CompaniesTable />}
          />
          <Route path={CONSTANT_ROUTES.COMPANY_ADD} element={<AddCompany />} />
          <Route
            path={CONSTANT_ROUTES.PARTIES_TABLE}
            element={<PartiesTable />}
          />
          <Route path={CONSTANT_ROUTES.PARTY_ADD} element={<AddParty />} />
          <Route
            path={CONSTANT_ROUTES.WEIGHMENTS_TABLE}
            element={<WeighmentEntryTable />}
          />
          <Route
            path={CONSTANT_ROUTES.WEIGHMENT_ADD}
            element={<AddWeighmentEntry />}
          />
          <Route
            path={CONSTANT_ROUTES.SECOND_WEIGHT_ADD}
            element={<AddSecondWeight />}
          />
          <Route
            path={CONSTANT_ROUTES.FINAL_WEIGHT_ADD}
            element={<AddFinalWeight />}
          />
          <Route
            path={CONSTANT_ROUTES.INDICATORS_TABLE}
            element={<IndicatorsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.INDICATOR_ADD}
            element={<AddIndicator />}
          />
          <Route path={CONSTANT_ROUTES.SITE_TABLE} element={<SiteTable />} />
          <Route path={CONSTANT_ROUTES.SITE_ADD} element={<AddSite />} />

          {/* ============================Ecommerce================================= */}

          <Route path={CONSTANT_ROUTES.ORDERS} element={<OrdersTable />} />
          <Route path={CONSTANT_ROUTES.ORDER_ADD} element={<AddOrder />} />
          <Route path={CONSTANT_ROUTES.PAYMENTS} element={<PaymentsTable />} />
          <Route path={CONSTANT_ROUTES.PAYMENT_ADD} element={<AddPayment />} />
          <Route path={CONSTANT_ROUTES.SHIPPING} element={<ShippingTable />} />
          <Route
            path={CONSTANT_ROUTES.SHIPPING_ADD}
            element={<AddShipping />}
          />
          <Route
            path={CONSTANT_ROUTES.PROMOTIONS}
            element={<PromotionsTable />}
          />
          <Route
            path={CONSTANT_ROUTES.PROMOTION_ADD}
            element={<AddPromotion />}
          />
          <Route path={CONSTANT_ROUTES.REVIEWS} element={<ReviewsTable />} />
          <Route path={CONSTANT_ROUTES.REVIEW_ADD} element={<AddReview />} />
          <Route path={CONSTANT_ROUTES.CARTS} element={<CartItemsTable />} />
          <Route path={CONSTANT_ROUTES.CART_ADD} element={<AddCartItem />} />
          <Route path={CONSTANT_ROUTES.WISHLISTS} element={<WishListTable />} />
          <Route
            path={CONSTANT_ROUTES.WISHLIST_ADD}
            element={<AddWishlist />}
          />

          {/*============================FBR=========================  */}

          <Route path={CONSTANT_ROUTES.SELLERS} element={<SellersTable />} />
          <Route path={CONSTANT_ROUTES.SELLER_ADD} element={<AddSeller />} />
          <Route
            path={CONSTANT_ROUTES.PRODUCT_VIEW_PAGE}
            element={<AddProduct />}
          />
          <Route
            path={CONSTANT_ROUTES.MARQUEE_MESSAGES_TABLE}
            element={<MarqueeMessageTable />}
          />
          <Route
            path={CONSTANT_ROUTES.MARQUEE_MESSAGES_ADD}
            element={<AddMarqueeMessage />}
          />
          <Route
            path={CONSTANT_ROUTES.MARQUEE_MESSAGES_TABLE_TEST}
            element={<TableView />}
          />
          <Route
            path={CONSTANT_ROUTES.MARQUEE_MESSAGES_ADD_TEST}
            element={<AddMarqueeMessageTest />}
          />
          <Route
            path={CONSTANT_ROUTES.MARQUEE_MESSAGES_TABLE_TEST_ONE}
            element={<TableViewTestOne />}
          />

          <Route
            path={CONSTANT_ROUTES.APPROVAL_REQUESTS_TABLE}
            element={<ApprovalRequestsTable />}
          />

          {/* <Route
            path={CONSTANT_ROUTES.DIGITAL_INVOICES}
            element={
              <DigitalInvoiceContextProvider>
                <DigitalInvoiceTable />
              </DigitalInvoiceContextProvider>
            }
          />
          <Route
            path={CONSTANT_ROUTES.DIGITAL_INVOICE_ADD}
            element={
              <DigitalInvoiceContextProvider>
                <AddDigitalInvoice />
              </DigitalInvoiceContextProvider>
            }
          /> */}

          {/*============================FBR End=========================  */}

          {/*============================Super Administration End=========================  */}

          {/*=======Pages  ======*/}

          <Route path={CONSTANT_ROUTES.USERPROFILE} element={<Profile />} />
          <Route path="/icon-example" element={<ImageIconExample />} />
          {/* <Route path={"/calender"} element={<Calendar />} />
          <Route path={"/timeline"} element={<Timeline />} />
          <Route path={"/tree-view"} element={<TreeViewFalconExample />} />
          <Route path={"/dynamic-form"} element={<DynamicForm />} />*/}
          {/* <Route path={"/dnd-example"} element={<DndExampleComponent />} /> */}
          {/* <Route path={"/dnd-example"} element={<FieldSetsFormExample />} />
          <Route element={<WizardAuth />}>
            <Route path="/home/wizard" element={<Wizard validation={true} />} />
            <Route
              path="/home/get-an-estimate"
              element={<GetAnEstimate validation={true} />}
            />
          </Route> */}
        </Route>
      </Route>

      {/* <Route path="/example" element={<SunTextEditor />} /> */}
      {/* <Route path="/example" element={<VoucherExample />} />
      <Route path="/qr" element={<QrCodeExample />} />
      <Route path="/import-excel" element={<ExcelToAgGrid />} /> */}

      {/* //--- MainLayout end  */}

      {/* <Navigate to="/errors/404" /> */}
      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
